import React, { Component } from 'react';
import './styles.css';

class BodyContent extends Component {
	render() {
		return (
			<div className="results-document-layout-body-content">
				{this.props.children}
			</div>
		);
	}
}

export default BodyContent;
